<section class="main-content wrapper content-padding">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab"> NOTIFICATIONS </a>
      </label>
    </div>
    <div class="column-box">
      <div class="column-inner-other-user">
        <ng-container *ngIf="notifications.length; else noNotifications">
            <n3-swipe-list
              [data]="dataArray"
              [options]="options"
              (singleChangedData)="onOutput($event)">
            </n3-swipe-list>
          </ng-container>

        <ng-template #noNotifications>
          <span>NO NOTIFICATIONS</span>
        </ng-template>
      </div>
      <!--Old View
      <ng-container *ngIf="notifications.length; else noNotifications">
        <div class="column-inner-other-user" *ngFor="let notification of notifications, index as i" (click)="redirectUser(showNotificationInfo(notification)?.intendUrl)">
          <div class="card-container" (click)="toggleAccordion(i)">
            <div class="action-btns">
              <div class="action-title">
                <h3>
                  <b class="info">{{ showNotificationInfo(notification)?.title }}</b>
                </h3>
              </div>
              <div class="action-icons">
                <a *ngIf="showNotificationInfo(notification)?.intendUrl" matTooltip="" class="action-icon" style="color: #F44336;" [href]="showNotificationInfo(notification)?.intendUrl" target="_blank">
                  <i class="material-icons" style="cursor: pointer !important;">open_in_new</i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noNotifications>
        <span>NO NOTIFICATIONS</span>
      </ng-template>
      Old View-->
    </div>
  </div>
</section>
